<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Details Info.</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"
    ></button>
</div>
<div class="modal-body">
    <div class="col-12">
        <div class="card">
            <div class="card-body" [formGroup]="detailForm" (ngSubmit)="upsertDetail()">
                <div class="row mb-3">
                    <div class="col-md-2">
                        <div class="mb-2">
                            <label class="form-label" for="calculatetype">Calculate Type</label>
                            <ng-select id="calculatetype" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                [items]="calculateTypeOptions" bindLabel="name" [bindValue]="'name'"
                                formControlName="ddlCalculationType" [clearable]="false" >
                            </ng-select>
                        </div>
                    </div>

                    <div class="col-md-5">
                        <div class="mb-2">
                            <label for="weight" class="form-label">Weight</label>
                            <div class="input-group mb-2">
                                <span class="input-group-text group-label-sm">Min<span
                                        class="mandatory">*</span></span>
                                <input class="form-control form-control-sm" type="text"
                                    formControlName="txtMin" id="from"
                                    [ngClass]="{'is-invalid': (isDetailFormSubmitted || detailForm.get('txtMin')?.touched) && detailForm.get('txtMin').errors}" >

                                <span class="input-group-text group-label-sm">Max<span
                                        class="mandatory">*</span></span>
                                <input class="form-control form-control-sm" type="text"
                                    formControlName="txtMax" id="toDate"
                                    [ngClass]="{'is-invalid': (isDetailFormSubmitted || detailForm.get('txtMax')?.touched) && detailForm.get('txtMax').errors}" >
                            </div>
                            <div>
                                <div *ngIf="(isDetailFormSubmitted || detailForm.get('txtMin')?.touched) && detailForm.get('txtMin').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="detailForm.get('txtMin').errors.required">From
                                        is required</span>
                                    <span *ngIf="detailForm.get('txtMin').errors.pattern">Invalid
                                        Format.</span>
                                </div>

                                <div *ngIf="(isDetailFormSubmitted || detailForm.get('txtMax')?.touched) && detailForm.get('txtMax').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="detailForm.get('txtMax').errors.required">To
                                        is required</span>
                                    <span *ngIf="detailForm.get('txtMax').errors.pattern">Invalid
                                        Format.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="mb-2">
                            <label class="form-label" for="value">Amount<span
                                    class="mandatory">*</span></label>
                            <input class="form-control form-control-sm" type="number"
                                formControlName="txtAmount" id="value"
                                [ngClass]="{'is-invalid': (isDetailFormSubmitted || detailForm.get('txtAmount')?.touched) && detailForm.get('txtAmount').errors}" >
                            <div *ngIf="(isDetailFormSubmitted || detailForm.get('txtAmount')?.touched) && detailForm.get('txtAmount').errors"
                                class="invalid-feedback">
                                <span *ngIf="detailForm.get('txtAmount').errors.required">Amount
                                    is required</span>
                                <span *ngIf="detailForm.get('txtAmount').errors.pattern">Invalid
                                    Formate</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="mb-2">
                            <label class="form-label" for="roundoff">Round Off</label>
                            <ng-select id="roundoff" placeholder="Select" [items]="roundOff"
                                bindLabel="name" [bindValue]="'name'" formControlName="ddlRoundOff" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                [clearable]="false" >
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                            <button type="submit" class="btn btn-primary btn-md" (click)="upsertDetail()">{{isDetailEdit? 'Update': 'Add'}}</button>
                            <button type="button" class="btn btn-secondary btn-md" (click)="resetDetailForm()">Cancel</button>
                    </div>
                </div>

                <div class="row">
                    <div class="card-header bg-transparent border-bottom text-uppercase"> Mapping
                        Details</div>
                    <div class="col-md-12 ">
                        <ag-grid-angular #agGrid id="myGrid" class="ag-theme-balham"
                            [rowData]="mappingDetailsRowData" [columnDefs]="mappingDetailsColumnDefs"
                            [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                            [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                            (gridReady)="onGridReady($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
